/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEmployees200ResponseInner
 */
export interface GetEmployees200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetEmployees200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployees200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployees200ResponseInner
     */
    accessPin?: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployees200ResponseInner
     */
    tillId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmployees200ResponseInner
     */
    tillEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmployees200ResponseInner
     */
    posAccess: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetEmployees200ResponseInner
     */
    position: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetEmployees200ResponseInner
     */
    privileges: Array<GetEmployees200ResponseInnerPrivilegesEnum>;
    /**
     * 
     * @type {Date}
     * @memberof GetEmployees200ResponseInner
     */
    clockIn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEmployees200ResponseInner
     */
    clockOut?: Date;
}


/**
 * @export
 */
export const GetEmployees200ResponseInnerPrivilegesEnum = {
    ProductManager: 'PRODUCT_MANAGER',
    CashDrawer: 'CASH_DRAWER',
    RealTimeReporter: 'REAL_TIME_REPORTER',
    DeliveryManager: 'DELIVERY_MANAGER',
    DiscountManager: 'DISCOUNT_MANAGER',
    TillManager: 'TILL_MANAGER',
    ShiftManager: 'SHIFT_MANAGER',
    OpenProductsCreator: 'OPEN_PRODUCTS_CREATOR',
    CloseTabAsManager: 'CLOSE_TAB_AS_MANAGER',
    BilledProductRemoval: 'BILLED_PRODUCT_REMOVAL',
    KitchenProductRemoval: 'KITCHEN_PRODUCT_REMOVAL'
} as const;
export type GetEmployees200ResponseInnerPrivilegesEnum = typeof GetEmployees200ResponseInnerPrivilegesEnum[keyof typeof GetEmployees200ResponseInnerPrivilegesEnum];


/**
 * Check if a given object implements the GetEmployees200ResponseInner interface.
 */
export function instanceOfGetEmployees200ResponseInner(value: object): value is GetEmployees200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tillEnabled' in value) || value['tillEnabled'] === undefined) return false;
    if (!('posAccess' in value) || value['posAccess'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('privileges' in value) || value['privileges'] === undefined) return false;
    return true;
}

export function GetEmployees200ResponseInnerFromJSON(json: any): GetEmployees200ResponseInner {
    return GetEmployees200ResponseInnerFromJSONTyped(json, false);
}

export function GetEmployees200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmployees200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'accessPin': json['accessPin'] == null ? undefined : json['accessPin'],
        'tillId': json['tillId'] == null ? undefined : json['tillId'],
        'tillEnabled': json['tillEnabled'],
        'posAccess': json['posAccess'],
        'position': json['position'],
        'privileges': json['privileges'],
        'clockIn': json['clockIn'] == null ? undefined : (new Date(json['clockIn'])),
        'clockOut': json['clockOut'] == null ? undefined : (new Date(json['clockOut'])),
    };
}

export function GetEmployees200ResponseInnerToJSON(json: any): GetEmployees200ResponseInner {
    return GetEmployees200ResponseInnerToJSONTyped(json, false);
}

export function GetEmployees200ResponseInnerToJSONTyped(value?: GetEmployees200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'accessPin': value['accessPin'],
        'tillId': value['tillId'],
        'tillEnabled': value['tillEnabled'],
        'posAccess': value['posAccess'],
        'position': value['position'],
        'privileges': value['privileges'],
        'clockIn': value['clockIn'] == null ? undefined : ((value['clockIn']).toISOString()),
        'clockOut': value['clockOut'] == null ? undefined : ((value['clockOut']).toISOString()),
    };
}

